import { ProductFeature, ProductFeatureStatus } from "components/product/product.types";
import { PlanProps } from "shared/components/plan/plan";
import { PlanOfferings } from "shared/constants/plans";
import { createItems } from "shared/constants/utilities";

export const GLACI_FEATURES: ProductFeature[] = [{
  id: 'playbooks',
  name: 'Custom Playbooks',
  description: 'Create & run promptable playbooks to prevent user fatigue and reduce human error through ganular access controls and validation over user inputs',
  isFeatured: true,
  isHidden: false,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'opportunities',
  name: 'Custom Opportunities',
  description: 'Get real-time suggestions on cross-selling opportunities as you serve members in realtime',
  isFeatured: true,
  isHidden: false,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'revamped-work-areas',
  name: 'Revamped Work Areas',
  description: 'We\'ve reimagined key work areas like Batch and Print Control with blazing fast & elegant user interfaces accessible at any time, with the stroke of a key',
  isFeatured: false,
  isHidden: false,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'publish-procedures',
  name: 'Publish Procedures',
  description: 'Centralize & beautify your credit union procedures and make them available to all employees',
  isFeatured: false,
  isHidden: false,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'track-goals',
  name: 'Goal Tracking',
  description: 'Stay on top of personal and company goals with our goal tracking feature',
  isFeatured: false,
  isHidden: false,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'quick-search',
  name: 'Quick Search',
  description: 'Use CTRL + K to view and navigate to recent accounts, or search for a member by name, SSN, or account number',
  isFeatured: false,
  isHidden: true,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'over-the-air-updates',
  name: 'Over-the-Air Updates',
  description: 'Keep your credit union future-proof with constant feature updates delivered over-the-air',
  isFeatured: false,
  isHidden: true,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}, {
  id: 'single-sign-on',
  name: 'Single Sign-On (SSO)',
  description: 'Sit back and let us handle the full login flow single sign-on through some of your favorite providers',
  isFeatured: false,
  isHidden: true,
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
}];

export const GLACI_PLAN_FEATURES = [{
  name: 'Integration with the Symitar core platform',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
  }, {
    name: PlanOfferings.GLACI,
  }]
}, {
  name: 'Quick account search overlay',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
  }, {
    name: PlanOfferings.GLACI,
  }]
}, {
  name: 'Feature updates delivered over-the-air',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
  }, {
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Single sign-on (SSO) with Symitar',
  offerings: [{
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Custom Playbooks',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
    description: 'Up to 5 Playbooks',
  }, {
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Custom Opportunities for cross-selling',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
    description: 'Up to 5 Opportunities',
  }, {
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Publish credit union procedures for employees',
  offerings: [{
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Overlay for Batch Control',
  offerings: [{
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Overlay for Print Control',
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
  }, {
    name: PlanOfferings.GLACI,
  }],
}, {
  name: 'Track personal and company goals',
  offerings: [{
    name: PlanOfferings.GLACI,
  }],
}];
export const GLACI_PLAN_FEATURES_MAP = createItems(GLACI_PLAN_FEATURES, 'glaci');

export const GLACI_PLAN: PlanProps = {
  header: 'Use Glaci for free, or subscribe for the full experience',
  features: GLACI_PLAN_FEATURES_MAP,
  offerings: [{
    name: PlanOfferings.GLACI_FREE,
    icon: '/logos/glaci_free',
    id: 'offering-glaci-free',
    class: 'glaci',
    link: {
      href: '',
      text: 'Coming Soon',
    }
  }, {
    name: PlanOfferings.GLACI,
    icon: '/logos/glaci',
    id: 'offering-glaci',
    class: 'glaci',
    link: {
      href: '',
      text: 'Coming Soon',
    }
  }]
}
